import { ButtonProps } from "flowbite-react";
import { ReactNode } from "react";

export interface AppButtonProps extends ButtonProps {
  color?: string;
  onClick?: () => void;
  size?: "sm" | "md" | "lg";
  text?: ReactNode | string;
  className?: string;
  disabled?: boolean;
  iconleft?: React.ReactNode;
  iconright?: React.ReactNode;
  disable?: boolean;
  type?: "button" | "submit" | "reset";
  wFull?: boolean;
}

interface AppStyle {
  [key: string]: string;
}

export const styles: AppStyle = {
  primary:
    "bg-yellow-200 hover:brightness-[97%] active:brightness-[94%] dark:bg-yellow-300 dark:hover:brightness-[94%] dark:active:brightness-[85%] text-yellow-900",
  secondary:
    "bg-black/5 dark:bg-gray-800 hover:bg-black/[7.5%] dark:hover:brightness-105 active:bg-black/10 dark:active:brightness-110",
  tertiary:
    "border-2 border-yellow-900 dark:border-gray-500 text-yellow-900 dark:text-gray-300 hover:bg-black/5 active:bg-black/10 dark:hover:bg-white/[2.5%] dark:active:bg-white/5",
  danger:
    "bg-red-500 dark:bg-red-800 text-white hover:brightness-[95%] active:brightness-[90%]",
  dangerSecondary:
    "border-2 border-red-500 dark:border-red-800 text-red-500 dark:text-red-700 hover:bg-red-500/5 active:bg-red-800/10 dark:hover:bg-white/[2.5%] dark:active:bg-white/5",
  success:
    "bg-green-500 dark:bg-green-600 text-white text-white hover:brightness-[95%] active:brightness-[90%]",
};

const sizes = {
  sm: "py-1.5 px-3 text-sm",
  md: "py-2 px-4 text-base",
  lg: "py-3 px-6 text-lg",
};

const buttonStyle =
  "group relative flex items-stretch justify-center p-0.5 text-center font-medium transition-[color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow] focus:z-10 focus:outline-none border border-transparent";

const buttonDisabled = "cursor-not-allowed opacity-50";

const width = ["w-auto", "w-full"];

// extends Button
export const AppButton: React.FC<AppButtonProps> = ({
  color = "primary",
  size = "lg",
  onClick = () => {},
  text = "Button",
  className = "",
  disabled = false,
  iconleft,
  iconright,
  wFull = true,
  type = "button",
  ...props
}) => {
  return (
    <button
      {...props}
      {...{ disabled: disabled }}
      type={type}
      onClick={onClick}
      className={`${buttonStyle} rtl:flex-row-reverse font-dialog rounded-xl max-w-[800px] mx-auto ${sizes[size]} ${styles[color]} ${width[Number(wFull)]} ${className} ${disabled && buttonDisabled}`}
    >
      {iconleft}
      {text}
      {iconright}
    </button>
  );
};
